import { AxiosResponse } from "axios";
import {
  BasePagination,
  CommonResponse,
} from "./interfaces/commonInterface.interface";
import { AxiosInstance } from "./axiosInstance";
import qs from "qs";
import {
  CreateGenerateKeyResponse,
  GetLyveListResponse,
  LicenseData,
  GetServicePricingResponse,
  ServicePricingResponse,
  GetSubscriptionKeyResponse,
  PostGenerateKeyRequest,
  GetServiceResponse,
  GetPricingResponse,
  PostCpCheckoutKeyRequest,
  PostCpCheckoutKeyResponse,
  PostCpCheckoutCompleteRequest,
  PostReplaceKeyRequest,
  PostCpCheckoutCompleteResponse,
  PostCheckActivateResponse,
  ActivateKey,
  SUBSCRIPTION_TYPE,
  EuRequestResponse,
  EuRequestType,
  SubscriptionKeyListReqeust,
  SubscriptionOrgInfoResponse,
  SubscriptionDetailSummaryResponse,
  SusbcriptonOrgListResponse,
  SubscriptionKeyPriceResponse,
  SendEmailRequest,
  UpdateLyveStorageSizeRequest,
  UpdateLyveStorageSizeResponse,
  SubscriptionRequestListResponse,
  SubscriptionStorageChangeResponse,
  GetSubscriptionInstallerResponse,
  CUMULUS_TYPE,
} from "./interfaces/subscription.interface";

const SUBSCRIPTION_API_PATH = "/subscription";

export const getLyveList = async ({
  payload,
  provider,
}: {
  payload: BasePagination;
  provider: CUMULUS_TYPE;
}): Promise<GetLyveListResponse> => {
  try {
    const { data }: AxiosResponse<GetLyveListResponse> =
      await AxiosInstance.get(
        `${SUBSCRIPTION_API_PATH}/list/${provider}?${qs.stringify(payload)}`
      );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const getLyveHistoryList = async ({
  payload,
  bucketName,
  provider,
}: {
  payload: BasePagination;
  bucketName: string;
  provider: CUMULUS_TYPE;
}): Promise<GetLyveListResponse> => {
  try {
    const { data }: AxiosResponse<GetLyveListResponse> =
      await AxiosInstance.get(
        `${SUBSCRIPTION_API_PATH}/list/${provider}/${bucketName}?${qs.stringify(
          payload
        )}`
      );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const getSubscriptionInstallerList = async ({
  accountId,
}: {
  accountId: string;
}): Promise<GetSubscriptionInstallerResponse> => {
  try {
    const { data }: AxiosResponse<GetSubscriptionInstallerResponse> =
      await AxiosInstance.get(
        `${SUBSCRIPTION_API_PATH}/installer/list/${accountId}`
      );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const getDiscountService =
  async ({}: {}): Promise<GetServicePricingResponse> => {
    try {
      const { data }: AxiosResponse<GetServicePricingResponse> =
        await AxiosInstance.get(`${SUBSCRIPTION_API_PATH}/tier`);
      return data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  };

export const getService = async ({}: {}): Promise<GetServiceResponse> => {
  try {
    const { data }: AxiosResponse<GetServiceResponse> = await AxiosInstance.get(
      `${SUBSCRIPTION_API_PATH}/tier/service`
    );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};
export const getDiscountTier = async ({}: {}): Promise<GetPricingResponse> => {
  try {
    const { data }: AxiosResponse<GetPricingResponse> = await AxiosInstance.get(
      `${SUBSCRIPTION_API_PATH}/tier/discount`
    );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const getDiscountYear = async ({}: {}): Promise<GetPricingResponse> => {
  try {
    const { data }: AxiosResponse<GetPricingResponse> = await AxiosInstance.get(
      `${SUBSCRIPTION_API_PATH}/tier/discountYear`
    );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const getSubscriptionKeyList = async ({
  payload,
  accountId,
}: {
  payload: SubscriptionKeyListReqeust;
  accountId: string;
}): Promise<GetSubscriptionKeyResponse> => {
  try {
    const { data }: AxiosResponse<GetSubscriptionKeyResponse> =
      await AxiosInstance.get(
        `${SUBSCRIPTION_API_PATH}/key/list/${accountId}?${qs.stringify(
          payload
        )}`
      );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const getSubscriptionDetailSummary = async ({
  accountId,
  type,
}: {
  accountId: string;
  type: SUBSCRIPTION_TYPE;
}): Promise<SubscriptionDetailSummaryResponse> => {
  try {
    const { data }: AxiosResponse<SubscriptionDetailSummaryResponse> =
      await AxiosInstance.get(
        `${SUBSCRIPTION_API_PATH}/detail/summary/${type}/${accountId}`
      );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const getSubscriptionDetailAccount = async ({
  accountId,
}: {
  accountId: string;
}): Promise<SubscriptionOrgInfoResponse> => {
  try {
    const { data }: AxiosResponse<SubscriptionOrgInfoResponse> =
      await AxiosInstance.get(
        `${SUBSCRIPTION_API_PATH}/detail/account/${accountId}`
      );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const getRequestKeyType = async ({
  accountId,
}: {
  accountId: string;
}): Promise<EuRequestResponse> => {
  try {
    const { data }: AxiosResponse<EuRequestResponse> = await AxiosInstance.get(
      `${SUBSCRIPTION_API_PATH}/request/${accountId}`
    );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const getSubscriptonOrgList = async ({
  accountId,
  payload,
}: {
  accountId: string;
  payload: BasePagination;
}): Promise<SusbcriptonOrgListResponse> => {
  try {
    const { data }: AxiosResponse<SusbcriptonOrgListResponse> =
      await AxiosInstance.get(
        `${SUBSCRIPTION_API_PATH}/account/list/${accountId}?${qs.stringify(
          payload
        )}`
      );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const getSubscriptonKeyPrice = async ({
  accountId,
}: {
  accountId: string;
}): Promise<SubscriptionKeyPriceResponse> => {
  try {
    const { data }: AxiosResponse<SubscriptionKeyPriceResponse> =
      await AxiosInstance.get(
        `${SUBSCRIPTION_API_PATH}/key/price/${accountId}`
      );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const getSubscriptonRequestList = async ({
  accountId,
  payload,
  isConfirm,
}: {
  accountId: string;
  payload: BasePagination;
  isConfirm?: boolean;
}): Promise<SubscriptionRequestListResponse> => {
  try {
    const params = {
      ...payload,
      ...(isConfirm !== undefined ? { isConfirm } : {}),
    };

    const { data }: AxiosResponse<SubscriptionRequestListResponse> =
      await AxiosInstance.get(
        `${SUBSCRIPTION_API_PATH}/request/list/${accountId}?${qs.stringify(
          params
        )}`
      );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};
export const getSubscriptonStorageChange = async ({
  accountId,
  payload,
}: {
  accountId: string;
  payload?: { userFixedStorage?: number };
}): Promise<SubscriptionStorageChangeResponse> => {
  try {
    const { data }: AxiosResponse<SubscriptionStorageChangeResponse> =
      await AxiosInstance.get(
        `${SUBSCRIPTION_API_PATH}/storage/change/${accountId}?${qs.stringify(
          payload
        )}`
      );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const createGenerateKey = async ({
  payload,
}: {
  payload: LicenseData;
}): Promise<CreateGenerateKeyResponse> => {
  try {
    const { data }: AxiosResponse<CreateGenerateKeyResponse> =
      await AxiosInstance.post(`${SUBSCRIPTION_API_PATH}/generate`, payload);
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const postRequestKey = async ({
  accountId,
  payload,
}: {
  accountId: string;
  payload: EuRequestType;
}): Promise<EuRequestResponse> => {
  try {
    const { data }: AxiosResponse<EuRequestResponse> = await AxiosInstance.post(
      `${SUBSCRIPTION_API_PATH}/request/${accountId}`,
      payload
    );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};
export const postRequestConfirmKeyType = async ({
  accountId,
  type,
  payload,
}: {
  accountId: string;
  type: SUBSCRIPTION_TYPE;
  payload: { confirmId: string[] };
}): Promise<EuRequestResponse> => {
  try {
    const { data }: AxiosResponse<EuRequestResponse> = await AxiosInstance.post(
      `${SUBSCRIPTION_API_PATH}/request/confirm/${type}/${accountId}`,
      payload
    );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};
export const postRegisterKey = async ({
  accountId,
  payload,
}: {
  accountId: string;
  payload: string[];
}): Promise<PostCpCheckoutCompleteResponse> => {
  try {
    const { data }: AxiosResponse<PostCpCheckoutCompleteResponse> =
      await AxiosInstance.post(
        `${SUBSCRIPTION_API_PATH}/register_cp/${accountId}`,
        payload
      );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const postReplaceKey = async ({
  accountId,
  payload,
}: {
  accountId: string;
  payload: PostReplaceKeyRequest;
}): Promise<PostCpCheckoutCompleteResponse> => {
  try {
    const { data }: AxiosResponse<PostCpCheckoutCompleteResponse> =
      await AxiosInstance.post(
        `${SUBSCRIPTION_API_PATH}/replace_key/${accountId}`,
        payload
      );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const postMyDwGenerateKey = async ({
  accountId,
  payload,
}: {
  accountId: string;
  payload: PostGenerateKeyRequest;
}): Promise<GetServicePricingResponse> => {
  try {
    const { data }: AxiosResponse<GetServicePricingResponse> =
      await AxiosInstance.post(
        `${SUBSCRIPTION_API_PATH}/mydw_generate/${accountId}`,
        payload
      );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const postExportKeyList = async ({
  accountId,
  payload,
}: {
  accountId: string;
  payload: SubscriptionKeyListReqeust;
}): Promise<Blob> => {
  try {
    const { data }: AxiosResponse<Blob> = await AxiosInstance.post(
      `${SUBSCRIPTION_API_PATH}/key/list/export/${accountId}?${qs.stringify(
        payload
      )}`,
      null,
      {
        responseType: "blob",
      }
    );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const postCpCheckoutKey = async ({
  accountId,
  payload,
}: {
  accountId: string;
  payload: PostCpCheckoutKeyRequest;
}): Promise<PostCpCheckoutKeyResponse> => {
  try {
    const { data }: AxiosResponse<PostCpCheckoutKeyResponse> =
      await AxiosInstance.post(
        `${SUBSCRIPTION_API_PATH}/checkout/${accountId}`,
        payload
      );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const postCpCheckoutCompleteKey = async ({
  accountId,
  payload,
}: {
  accountId: string;
  payload: PostCpCheckoutCompleteRequest;
}): Promise<PostCpCheckoutKeyResponse> => {
  try {
    const { data }: AxiosResponse<PostCpCheckoutKeyResponse> =
      await AxiosInstance.post(
        `${SUBSCRIPTION_API_PATH}/complete/${accountId}`,
        payload
      );
    if (data.error === 0 && data.result) {
      return data;
    } else {
      throw data.error;
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const postEuCheckActivateKey = async ({
  accountId,
  payload,
}: {
  accountId: string;
  payload: { key: string; userFixedStorage?: number };
}): Promise<PostCheckActivateResponse> => {
  try {
    const { data }: AxiosResponse<PostCheckActivateResponse> =
      await AxiosInstance.post(
        `${SUBSCRIPTION_API_PATH}/check_activate/${accountId}`,
        payload
      );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const postEuActivateKey = async ({
  accountId,
  payload,
}: {
  accountId: string;
  payload: ActivateKey;
}): Promise<PostCpCheckoutKeyResponse> => {
  try {
    const { data }: AxiosResponse<PostCpCheckoutKeyResponse> =
      await AxiosInstance.post(
        `${SUBSCRIPTION_API_PATH}/activate/${accountId}`,
        payload
      );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const putDiscountService = async ({
  payload,
}: {
  payload: ServicePricingResponse;
}): Promise<GetServicePricingResponse> => {
  try {
    const { data }: AxiosResponse<GetServicePricingResponse> =
      await AxiosInstance.put(`${SUBSCRIPTION_API_PATH}/tier`, payload);
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const postRequestSendEmail = async ({
  accountId,
  payload,
}: {
  accountId: string;
  payload: SendEmailRequest & { id: string };
}): Promise<string> => {
  try {
    const { data }: AxiosResponse<string> = await AxiosInstance.post(
      `${SUBSCRIPTION_API_PATH}/request/sendEmail/${accountId}`,
      payload
    );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const postChangeStorage = async ({
  accountId,
  userFixedStorage,
}: {
  accountId: string;
  userFixedStorage: number;
}): Promise<string> => {
  try {
    const { data }: AxiosResponse<string> = await AxiosInstance.post(
      `${SUBSCRIPTION_API_PATH}/storage/change/${accountId}?userFixedStorage=${userFixedStorage}`
    );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const postCovaFreeKeyRenew = async ({
  accountId,
  dwKey,
}: {
  accountId: string;
  dwKey: string;
}): Promise<CommonResponse> => {
  try {
    const { data }: AxiosResponse<CommonResponse> = await AxiosInstance.post(
      `${SUBSCRIPTION_API_PATH}/cova/free/renew/${accountId}`,
      { dwKey }
    );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const postCovaFreeKeyReset = async ({
  accountId,
  dwKey,
  expirationDate,
}: {
  accountId: string;
  dwKey: string;
  expirationDate: string;
}): Promise<CommonResponse> => {
  try {
    const { data }: AxiosResponse<CommonResponse> = await AxiosInstance.post(
      `${SUBSCRIPTION_API_PATH}/cova/free/reset/${accountId}`,
      { dwKey, expirationDate }
    );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const updateLyveStorageSize = async (
  payload: UpdateLyveStorageSizeRequest
): Promise<UpdateLyveStorageSizeResponse> => {
  try {
    const { data }: AxiosResponse<UpdateLyveStorageSizeResponse> =
      await AxiosInstance.put(`${SUBSCRIPTION_API_PATH}/update`, payload);
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const deleteSubscriptionKey = async (dwKey: string): Promise<string> => {
  try {
    const { data }: AxiosResponse<string> = await AxiosInstance.delete(
      `${SUBSCRIPTION_API_PATH}/key/${dwKey}`
    );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};
